import Swiper from "swiper";
import { A11y, Autoplay, Pagination } from "swiper/modules";
import "@styles/components/slider.css";

document.querySelectorAll(".partners-slider").forEach((el) => {
  const container = el.querySelector(".swiper");
  const sliderPagination = el.querySelector(".slider-pagination");

  new Swiper(container, {
    modules: [A11y, Autoplay, Pagination],
    autoplay: {
      delay: 4000,
      pauseOnMouseEnter: true,
    },
    slidesPerView: 2,
    spaceBetween: 12,
    speed: 500,
    loop: true,
    pagination: {
      el: sliderPagination,
      clickable: true,
    },
    simulateTouch: false,
  });
});
